import {
  type RetryArticleAnalysisRes,
  type SaveArticleAnalysisReq,
  type SaveArticleAnalysisRes,
  retryArticleAnalysisReqSchema,
  saveArticleAnalysisReqSchema,
} from '../entity/api/routes/article';
import { apiRequest } from './request';

export async function updateArticleAnalysisById(
  ArticleId: SaveArticleAnalysisReq['params']['id'],
  data: SaveArticleAnalysisReq['body']
) {
  const req = saveArticleAnalysisReqSchema.parse({
    params: { id: ArticleId },
    query: null,
    body: data,
  });
  await apiRequest<SaveArticleAnalysisRes>(
    `/article/${req.params.id}/analysis`,
    'PATCH',
    true,
    req.body
  );
}

export async function retryAnalysisByArticleId(articleId: string) {
  const req = retryArticleAnalysisReqSchema.parse({
    params: { id: articleId },
    query: null,
    body: null,
  });
  return apiRequest<RetryArticleAnalysisRes>(
    `/article/${req.params.id}/analysis/retry`,
    'POST',
    true,
    req.body
  );
}
